/**
 * created by xcc on 2022/2/21
 * 媒体管理页面
 */
import React from 'react';
import { Table, Modal, Input, Tabs, Menu, Dropdown, Button, Pagination, InputNumber, Divider } from "antd";
import { message } from "../../sysManagement/utils/sysManagementUtils";
import { connect } from "react-redux";
import MediaAdd from "./MediaAdd";
import { Scrollbars } from "react-custom-scrollbars";
import {
    getDeptData,
    getMediaAdministerData,
    getMediaCountData,
    mediaAdministerDel, startOrDisableUsing, gotoOAuth,
    isOAuthSuccess, verifyWechat, verifyWebsite, getMediaTypeList, verifyBaiJiaHao, updateSiteColumnTree, saveSortData
} from "../actions/mediaAdminister";
import { decodeUnicode, formatTime } from "../../../utils";
import InfoAuth from "./InfoAuth";
import { setInfoToLocalStorage } from "../../../actions";
import website from "../images/website.png";
import wechat from "../images/wechat.png";
import douyin from "../images/tiktok.png";
import weibo from "../images/weibo.png";
import kuaishou from "../images/kuaishou.png";
import rmapp from "../images/rmapp.png";
import otherMedia from "../images/other.png";
import baijiahao from "../images/baijiahao.png";
import $ from "jquery";
import BaseComponent from "../../../base/BaseComponent";
import ButtonGroup from "antd/es/button/button-group";
import ExamineTree from "./examineTree";
import { uuid } from '../../../utils'
const { confirm } = Modal;

const { Search } = Input;
const { TabPane } = Tabs;
let height = window.innerHeight - 116;
let num = 0;

class MediaAdminister extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            isSys: this.props.match.params.isSys,
            page: 1,
            size: 10,
            total: 0,
            selectKey: 'all', //tab筛选
            searchValue: "",
            listData: [],  //列表数据
            mediaCountObj: {},
            addVisible: false,
            addTitle: "",
            departAllList: [], //所属部门
            mediaTypeCode: "", //媒体类型
            webInfoVisible: false,
            mediaPlatform: [],  //媒体类型List
            mediaPlatformNoAll: [],
            mediaTypeName: "",
            logoUrl: "",
            name: "",
            tempDataSource: [],
            hideOnSinglePage: true,
            examineTreeKey: uuid(),
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        //所属部门
        this.getDept();
        //媒体列表
        this.getMediaAdminister();
        //媒体类型
        this.getMediaType();
        //事件监听
        // window.addEventListener('resize', this.resize.bind(this));
    }

    // resize() {
    //     window.location.reload();   //重新加载页面，类似f5刷新
    // }
    //
    // componentWillUnmount() {
    //     // 一定要最后移除监听器，以防多个组件之间导致this的指向紊乱
    //     window.removeEventListener('resize', this.resize);
    // }

    /**
     * 所属部门
     **/
    getDept() {
        let params = {
            id: this.state.isSys === "true" ? "0" : window.top.currentUser.deptIds[0]
        };
        getDeptData(params, (data) => {
            let departAllList = [];
            if (data) {
                departAllList = [
                    {
                        name: data.name,
                        id: data.id,
                        sons: data.child,
                    },
                ];
            }
            this.setState({
                departAllList
            });
        });
    }

    /**
     * 获取媒体列表数据
     */
    getMediaAdminister() {
        let deptId = this.state.isSys === "true" ? "" : window.top.currentUser.deptIds[0];
        let params = {
            page: this.state.page,
            size: this.state.size,
            deptId: deptId,
            typeCode: this.state.selectKey
        };
        if (this.state.searchValue) {
            params.mediaName = this.state.searchValue
        }
        getMediaAdministerData(params, (res) => {
            let listData = [];
            let hideOnSinglePage = true;
            let total = 0;
            if (res && res.data && res.data.length) {
                listData = res.data;
                total = res.count;
                hideOnSinglePage = false;
                this.state.tempDataSource = JSON.parse(JSON.stringify(listData));   //深拷贝
            }
            this.setState({
                listData,
                total,
                hideOnSinglePage
            }, () => {
                $('.ant-pagination-options-quick-jumper').find("input").val("");
            })
        })
        //媒体数量
        this.getMediaCount();
    }

    /**
     * 获取各媒体数量
     */
    getMediaCount() {
        let deptId = this.state.isSys === "true" ? "" : window.top.currentUser.deptIds[0];
        getMediaCountData({ deptId: deptId }, (res) => {
            let mediaCountObj = {};
            if (res && res.length > 0) {
                res.forEach(item => {
                    mediaCountObj[item.mediaTypeCode] = item;
                })
                this.setState({
                    mediaCountObj
                })
            }
        })
    }

    /**
     * 媒体类型
     **/
    getMediaType() {
        getMediaTypeList({}, (data) => {
            let mediaPlatform = [{ "title": '全部', "mediaTypeCode": 'all' }];
            let mediaPlatformNoAll = [];
            if (data && data.length > 0) {
                data.forEach(item => {
                    mediaPlatform.push({
                        "title": item.mediaTypeName,
                        "mediaTypeCode": item.mediaTypeCode,
                        "logoUrl": item.logoUrl
                    });
                });
                mediaPlatformNoAll = data;
            }
            this.setState({
                mediaPlatform,
                mediaPlatformNoAll
            });
        });
    }

    /**
     * tab切换
     */
    handleChange = key => {
        this.setState({
            page: 1,
            selectKey: key
        }, () => {
            this.getMediaAdminister();
        });
    };

    /**
     * 渲染
     */
    render() {
        return (
            <div style={{ margin: 15 }}>
                <div style={{
                    width: "100%",
                    height: height
                }}>
                    {/*渲染头部*/}
                    {this.renderHeader()}
                    {/*渲染内容*/}
                    {this.renderTable()}
                    {/*渲染新增页面*/}
                    <MediaAdd
                        title={this.state.addTitle}
                        onRef={(c) => this.mediaAdd = c}
                        addVisible={this.state.addVisible}
                        onCancelAdd={() => {
                            this.setState({
                                addVisible: false
                            })
                        }}
                        departAllList={this.state.departAllList}
                        mediaPlatformNoAll={this.state.mediaPlatformNoAll}
                        isSys={this.state.isSys}
                        getMediaAdminister={() => {
                            this.getMediaAdminister()
                        }}
                        openInfoVisible={(mediaTypeCode, name, mediaLogo, item) => {
                            this.openInfoVisible(mediaTypeCode, name, mediaLogo, item)
                        }}
                    />
                    {/*渲染信息认证*/}
                    <InfoAuth
                        webInfoVisible={this.state.webInfoVisible}
                        mediaTypeName={this.state.mediaTypeName}
                        mediaTypeCode={this.state.mediaTypeCode}
                        logoUrl={this.state.logoUrl}
                        name={this.state.name}
                        onRef={(c) => this.informationAuth = c}
                        infoAuthCancel={() => {
                            this.setState({
                                webInfoVisible: false
                            })
                        }}
                        infoAuth={(params) => {
                            this.infoAuth(params)
                        }}
                    />
                    <ExamineTree ref={ref => this.examineTree = ref} key={this.state.examineTreeKey} onCloseCall={() => { this.setState({ examineTreeKey: uuid() }) }} />
                </div>
            </div>
        )
    }

    //启用、禁用
    startOrForbidUsing(record) {
        let text = "禁用";
        let enable = 1;
        if (record.disable) {
            text = "启用";
            enable = 0;
        }
        let params = {
            enable: enable,
            mediaId: record.id
        }
        startOrDisableUsing(params, (data, status) => {
            if (status === 200) {
                message.success(`${text}成功！`);
                this.getMediaAdminister()
            }
        })
    }

    getMediaLogo(record) {
        let rmapp = "";
        if (record.rmType === 0) {
            rmapp = "images/rm/defaultType1.png"
        } else {
            rmapp = "images/rm/defaultType2.png"
        }
        let mediaLogo;
        if (record.mediaLogo) {
            mediaLogo = record.mediaLogo;
        } else {
            switch (record.mediaTypeCode) {
                case "webNews":
                    mediaLogo = website;
                    break;
                case "material":
                    mediaLogo = wechat;
                    break;
                case "weibo":
                    mediaLogo = weibo;
                    break;
                case "douyin":
                    mediaLogo = douyin;
                    break;
                case "kuaishou":
                    mediaLogo = kuaishou;
                    break;
                case "baijiahao":
                    mediaLogo = baijiahao;
                    break;
                case "rmapp":
                    mediaLogo = rmapp;
                    break;
                case "otherMedia":
                    mediaLogo = otherMedia;
                    break;
                default:
                    mediaLogo = null;
            }
        }
        return mediaLogo;
    }

    auth(record) {
        if (record.mediaTypeCode === "webNews" || record.mediaTypeCode === "material" || record.mediaTypeCode === "baijiahao") {
            this.state.webInfoVisible = true;
            this.state.mediaTypeName = record.mediaTypeName;
            this.state.mediaTypeCode = record.mediaTypeCode;

            this.state.logoUrl = this.getMediaLogo(record);
            this.state.name = record.name;
            this.setState({});
            this.informationAuth && this.informationAuth.revertInfoAuth(record);  //回显认证数据
        } else {
            gotoOAuth({ mediaId: record.id }, (res) => {
                let data = res;
                if (data && data.openurl) {
                    let openurl = decodeUnicode(data.openurl);//第三方认证链接
                    window.open(openurl);//打开第三方认证页面去认证
                    //刷新状态
                    this.getMediaAdminister();
                    num = 0;
                    this.refreshAuth(record.id, data.keycode, record.mediaTypeCode);
                }
            }, record.mediaTypeCode)
        }
    }

    //刷新认证状态
    refreshAuth(id, keyCode, mediaTypeCode) {
        let body = {
            keyCode: keyCode,
            mediaId: id,
        };
        let that = this;
        isOAuthSuccess(body, (res, status) => {
            if (!res) {
                //反复刷新认证状态
                if (num < 100) {
                    setTimeout(function () {
                        num++;
                        that.refreshAuth(id, keyCode, mediaTypeCode);
                    }, 3000);
                }
            }
            if (res) {
                //刷新列表
                that.getMediaAdminister();
            }
        }, () => {
        }, mediaTypeCode);
    }

    renderTable() {
        const columns = [
            {
                title: '媒体名称',
                key: 'name',
                width: 150,
                render: (record) => {
                    return (
                        <div title={record.name} style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            width: 160,
                        }}>{record.name}
                        </div>
                    )
                }
            },
            {
                title: '媒体类型',
                key: 'type',
                width: 100,
                render: (record) => {
                    let mediaLogo = this.getMediaLogo(record);
                    return (
                        <div style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "flex",
                            justifyContent: "flex-start"
                        }}><img style={{
                            verticalAlign: "midden",
                            width: "20px",
                            height: "20px",
                            objectFit: "cover",
                            borderRadius: "50%"
                        }}
                            alt={""} src={record.mediaLogo ? record.mediaLogo : mediaLogo} /><span
                                title={record.mediaTypeName}
                                style={{ marginLeft: "5px", verticalAlign: "middle" }}>{record.mediaTypeName}</span></div>
                    )
                }
            },
            {
                title: '媒体管理员',
                key: 'manager',
                width: 150,
                render: (record) => {
                    let accountNames = [];
                    record.chooseUsers && record.chooseUsers.length > 0 && record.chooseUsers.forEach(i => {
                        accountNames.push(i.name);
                    })
                    return (
                        <div title={accountNames && accountNames.length > 0 ? accountNames.join("，") : ""} style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            width: 150,
                        }}>{accountNames && accountNames.length > 0 ? accountNames.join("，") : "-"} </div>
                    )
                }
            },
            {
                title: '所属部门',
                key: 'deptName',
                width: 130,
                render: (record) => {
                    return (
                        <div title={record.deptName} style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            width: 130,
                        }}>{record.deptName}</div>
                    )
                }
            },
            {
                title: '媒体排序',
                key: 'sort',
                width: 90,
                render: (record) => {
                    return (
                        <div><InputNumber
                            style={{ width: 60 }}
                            placeholder={"请输入"}
                            value={record.sort}
                            min={0}
                            onChange={(sort) => {
                                record.sort = sort;
                                this.setState({})
                            }}
                        /></div>
                    )
                }
            },
            {
                title: '认证状态',
                key: 'status',
                width: 90,
                render: (record) => {
                    return (
                        <div>
                            {(record.mediaTypeCode !== "otherMedia" && record.mediaTypeCode !== "rmapp") ?
                                <div><span style={{
                                    display: "inline-block",
                                    width: "10px",
                                    height: "10px",
                                    borderRadius: "50%",
                                    backgroundColor: record.authResult ? "#04D919" : "#F46C6D",
                                    marginRight: "5px"
                                }} />{record.authResult ? "已认证" : "未认证"}</div> : "-"}
                        </div>
                    )
                }
            },
            {
                title: '最近认证时间',
                key: 'time',
                width: 120,
                render: (record) => {
                    // console.log(record.mediaTypeCode, "111111111111")
                    let authTime = record.authTime ? formatTime(record.authTime) : "-"
                    return (
                        <div title={authTime} style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            width: 120,
                        }}>{authTime}</div>
                    )
                }
            },
            {
                title: '操作',
                key: 'action',
                width: 275,
                render: (text, record) => (
                    <span>
                        <span style={{
                            color: record.disable === 0 ? "#F46C6D" : "#04D919",
                            cursor: "pointer",
                            float: "left"
                        }}
                            onClick={() => this.startOrForbidUsing(record)}>{record.disable === 0 ? "禁用" : "启用"}</span>
                        {
                            (record.mediaTypeCode !== "otherMedia" && record.mediaTypeCode !== "rmapp") ?
                                <span style={{ marginLeft: "10px", color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), cursor: "pointer", float: "left" }}
                                    onClick={() => {
                                        this.auth(record)
                                    }}>{record.authResult === 1 ? "重新认证" : "认证"}</span> : null
                        }
                        <span style={{ marginLeft: "10px", color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), cursor: "pointer", float: "left" }}
                            onClick={() => this.update(record)}>修改</span>
                        <span style={{ marginLeft: "10px", color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), cursor: "pointer", float: "left" }}
                            onClick={() => this.delete(record)}>删除</span>
                        {
                            (record.authResult === 1 && record.mediaTypeCode === "webNews") ?
                                <span style={{ marginLeft: "10px", color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), cursor: "pointer", float: "left" }}
                                    onClick={() =>{
                                        console.log(record)
                                        this.updateWebColumn(record)}}>更新栏目</span> : null
                        }
                        {
                            (record.authResult === 1 && record.mediaTypeCode === "webNews") ?
                                <span style={{ marginLeft: "10px", color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), cursor: "pointer", float: "left" }}
                                    onClick={() => this.examineTree.showModal(record)}>查看栏目树</span> : null
                        }


                        {/*<span style={{marginLeft: "10px", color: "#0050B3", cursor: "pointer", float: "left"}}*/}
                        {/*      onClick={() => this.showConfirm(record)}>同步稿件</span>*/}
                        {record.mediaTypeCode === 'webNews'?<span style={{ marginLeft: "10px", color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), cursor: "pointer", float: "left" }}
                                                                  onClick={() => {
                                                                      this.mediaAdd.selectAdministrator(record)}
                                                                  }>绑定网站用户</span>:null}

                    </span>
                )
            }
        ];
        if (this.state.isSys === "true") {
            columns.splice(4, 1);
        }
        return (
            <div id={"table"} style={{ background: 'white', borderRadius: "0 0 5px 5px" }}>
                <div style={{ backgroundColor: "#ffffff", padding: "0 16px 10px 16px" }}>
                    <Scrollbars autoHide autoHeight autoHeightMax={this.state.isSys === "true" ? height - 158 : height - 168}>
                        <Table rowKey={(record) => record.id} columns={columns} dataSource={this.state.listData} pagination={false} />
                    </Scrollbars>
                </div>
                {/*<Divider style={{display: !this.state.listData.length ? "none" : "block"}}/>*/}
                <style>{`
                 #table .ant-table-tbody > tr > td{padding: ${this.state.isSys === "true" ? "20px" : "14px"} 16px !important;}
                #table .ant-divider-horizontal{margin: 2px 0px 10px 0px;}
                #table .ant-table-placeholder{border-bottom: 0;}
                `}</style>
                {this.state.listData && this.state.listData.length > 0 ? <div style={{
                    padding: this.state.isSys === "true" ? "11px 10px" : "16px 10px",
                    display: "flex",
                    justifyContent: "flex-end",
                    backgroundColor: "#ffffff",
                    borderTop: "1px solid #e6e6e6",
                    borderRadius: "0 0 5px 5px"
                }}>
                    <Pagination
                        onChange={(page, pageSize) => {
                            this.paginationOnChange(page, pageSize)
                        }}//页码改变回调
                        onShowSizeChange={(page, pageSize) => {
                            this.state.hideOnSinglePage = false;
                            this.paginationOnChange(page, pageSize)
                        }}//每页条数改变回调
                        defaultCurrent={1}
                        defaultPageSize={10}
                        total={this.state.total}
                        showTotal={total => `共${total}条`}
                        current={this.state.page}
                        pageSize={this.state.size}
                        showSizeChanger
                        showQuickJumper
                        hideOnSinglePage={this.state.hideOnSinglePage}
                    />
                </div> : ""}

                <style>{`
                    #table .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                `}</style>
            </div>
        )
    }

    update(record) {
        this.setState({
            addVisible: true,
            addTitle: "修改媒体"
        }, () => {
            this.mediaAdd.getItem(record);
        })
    }

    delete(record) {
        Modal.confirm({
            title: '确定删除该媒体？',
            content: "媒体删除后相关数据将会删除，此操作不可逆，请问是否继续？",
            onOk: () => {
                mediaAdministerDel({ mediaId: record.id }, (data, status) => {
                    if (status === 200) {
                        message.success("删除成功！");
                        if (this.state.listData.length === 1) {
                            this.paginationOnChange(this.state.page - 1, this.state.size)
                        } else {
                            this.paginationOnChange(this.state.page, this.state.size)
                        }
                    } else {
                        message.error("删除失败！");
                    }
                })
            }
        })
    }

    updateWebColumn(record) {
        updateSiteColumnTree({ mediaId: record.id }, (data, status) => {
            if (status === 200) {
                message.success("更新成功！");
                this.getMediaAdminister()
            }
        })
    }

    showConfirm = () => {
        confirm({
            title: '信息',
            content: '确定同步稿件',
            onOk() {
                console.log('OK');
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    openInfoVisible(mediaTypeCode, name, mediaLogo, item) {
        let mediaTypeName;
        let logoUrl;
        if (mediaTypeCode === "webNews") {
            mediaTypeName = "网站";
            logoUrl = website;
        } else if (mediaTypeCode === "material") {
            mediaTypeName = "公众号";
            logoUrl = wechat;
        } else {
            mediaTypeName = "百家号";
            logoUrl = baijiahao;
        }
        this.informationAuth && this.informationAuth.revertInfoAuth(item);  //清空认证数据
        this.setState({
            webInfoVisible: true,
            mediaTypeCode,
            mediaTypeName,
            logoUrl: mediaLogo ? mediaLogo : logoUrl,
            name
        })
    }

    infoAuth(params) {
        if (this.state.mediaTypeCode === "material" || this.state.mediaTypeCode === "baijiahao") {
            //校验公众号
            if (params.appId.trim().length === 0) {
                message.warn('请输入AppId！');
                return;
            }
            if (params.appSecret.trim().length === 0) {
                if (this.state.mediaTypeCode === "material") {
                    message.warn('请输入AppSecret！');
                } else {
                    message.warn('请输入AppToken！');
                }
                return;
            }
        } else {
            //校验网站
            if (!params.siteAddress) {
                message.warn("请选择站点地址！");
                return;
            }
            if (params.activeKey === "1") {
                if (!params.siteAccount || params.siteAccount.trim().length === 0 || !params.sitePassword || params.sitePassword.trim().length === 0) {
                    if (params.authResult) {
                        message.warn("请输入账号密码重新获取站点并绑定！");
                    } else {
                        message.warn("请输入账号密码获取站点并绑定！");
                    }
                    return;
                }
            }
            if (!params.bindSiteId) {
                if (params.authResult) {
                    message.warn("请重新获取站点并绑定！");
                } else {
                    message.warn("请获取站点并绑定！");
                }
                return;
            }
        }
        this.getAuthResult(params);  //认证
    }

    getAuthResult(params) {
        let mediaId = params.mediaId;
        if (this.state.mediaTypeCode === "material") {
            let body = {
                appId: params.appId,
                appSecret: params.appSecret,
                mediaId,
                type: params.wechatType
            };
            verifyWechat(body, (data, status) => {
                if (status === 200) {
                    this.setState({
                        webInfoVisible: false
                    });
                    this.getMediaAdminister();
                }
            }, {
                info: (info) => {
                    message.error(info);
                }
            })
        } else if (this.state.mediaTypeCode === "webNews") {
            let body = {
                clientId: params.siteAddress,
                mediaId,
                owner: params.bindSiteId,
                websiteName: params.websiteName
            };
            if (params.activeKey === "1") {
                body.account = params.siteAccount;
                body.password = params.sitePassword;
            }
            if (params.activeKey === "2") {
                body.account = window.top.currentUser.account;
            }
            verifyWebsite(body, (data, status) => {
                if (status === 200) {
                    this.setState({
                        webInfoVisible: false
                    });
                    this.getMediaAdminister();
                }
            }, {
                info: (info) => {
                    message.error(info);
                }
            })
        } else {
            let body = {
                appId: params.appId,
                appSecret: params.appSecret,
                mediaId
            };
            verifyBaiJiaHao(body, (data, status) => {
                if (status === 200) {
                    this.setState({
                        webInfoVisible: false
                    });
                    this.getMediaAdminister();
                }
            }, {
                info: (info) => {
                    message.error(info);
                }
            })
        }
    }

    paginationOnChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.getMediaAdminister();
    }

    //点击批量新增
    getBatchAdd() {
        let params = {
            key: "MediaAdministerBatchAddComponent",
            name: "批量新增"
        };
        setInfoToLocalStorage("MediaAdministerBatchAddComponent", params);
        this.props.history.push("/view/pms/MediaAdministerBatchAddComponent");
    }

    renderHeader() {
        const menu = <Menu style={{ width: 120 }}>
            <Menu.Item onClick={() => this.addNewMedia()}>新增媒体</Menu.Item>
            <Menu.Item onClick={() => {
                this.getBatchAdd();
            }}>批量新增</Menu.Item>
        </Menu>
        return (
            <div id={"newAddMedia"}
                style={{ background: 'white', padding: "15px 15px 15px 15px", borderRadius: "5px 5px 0 0" }}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: this.state.mediaPlatform && this.state.mediaPlatform.length > 0 ? "" : "20px"
                }}>
                    <div style={{ display: "flex" }}>
                        {this.state.isSys === "true" ?
                            <div style={{ marginRight: "20px" }}>
                                <Dropdown.Button
                                    onClick={() => {
                                        this.addNewMedia()
                                    }}
                                    type={"primary"}
                                    overlay={menu}
                                    placement="bottomRight">
                                    新增媒体
                                </Dropdown.Button>
                            </div> :
                            <div style={{ marginRight: "20px" }}>
                                <Button type={"primary"} onClick={() => {
                                    this.addNewMedia();
                                }}>新增媒体</Button>
                            </div>
                        }
                        {this.state.isSys === "true" ?
                            <div style={{ marginRight: "20px" }}>
                                <Button onClick={() => {
                                    this.props.history.push("/view/stationGroupManagement/StationGroupManagement");
                                }}>站群信息配置</Button>
                            </div> : null}
                        {
                            this.state.isSys === "true" ? null :
                                <Button onClick={() => {
                                    this.saveSort()
                                }}>保存排序</Button>}
                    </div>
                    <style>{`
                    #newAddMedia .ant-btn-group .ant-btn + .ant-btn{margin-left: 1px;}
                    `}</style>
                    <Search placeholder={"请输入媒体名称"} style={{ width: 250 }}
                        onSearch={(searchValue) => {
                            this.setState({ searchValue, page: 1 }, () => {
                                this.getMediaAdminister()
                            })
                        }} />
                </div>
                {
                    this.state.mediaPlatform && this.state.mediaPlatform.length > 0 ?
                        <Tabs activeKey={this.state.selectKey} onChange={this.handleChange}>
                            {this.state.mediaPlatform.map(item => {
                                let tabText = `${item.title}（${this.state.mediaCountObj && this.state.mediaCountObj[item.mediaTypeCode] ? this.state.mediaCountObj[item.mediaTypeCode].count : 0}）`
                                return (
                                    <TabPane key={item.mediaTypeCode}
                                        tab={<span>{item.logoUrl ? <img src={item.logoUrl} style={{
                                            width: "20px",
                                            height: "20px",
                                            objectFit: "cover",
                                            borderRadius: "50%"
                                        }} alt="" /> : null} <span
                                            style={{ verticalAlign: "middle" }}>{tabText}</span></span>} />
                                )
                            })}
                        </Tabs> : null
                }
            </div>
        )
    }

    addNewMedia() {
        this.mediaAdd.revert(); //清空
        this.mediaAdd.sortVerify(window.top.currentUser.deptIds[0]);  //新增回显当前用户所属部门媒体排序
        this.mediaAdd.state.activeKey = "1";
        this.setState({
            addVisible: true,
            addTitle: "新增媒体"
        })
    }

    saveSort() {
        let newSort = [];
        this.state.tempDataSource.forEach((item1) => {
            this.state.listData.forEach((item2) => {
                if (item1.id === item2.id && item1.sort !== item2.sort) {
                    newSort.push({ id: item2.id, sort: item2.sort });
                }
            })
        })
        saveSortData(newSort, (data, status) => {
            if (status === 200) {
                message.success("保存成功！");
                this.state.tempDataSource = [];
                this.getMediaAdminister();
            } else {
                message.error("保存失败！");
            }
        })
    }

}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(MediaAdminister);